import { render, staticRenderFns } from "./NivelacionesLayout.vue?vue&type=template&id=18489b5e&scoped=true"
import script from "./NivelacionesLayout.vue?vue&type=script&lang=js"
export * from "./NivelacionesLayout.vue?vue&type=script&lang=js"
import style0 from "./NivelacionesLayout.vue?vue&type=style&index=0&id=18489b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18489b5e",
  null
  
)

export default component.exports